import React from "react";

const NotFound = () => {
  return (
    <>
      <center>
        <img
          src="https://img.freepik.com/free-vector/oops-404-error-with-broken-robot-concept-illustration_114360-5529.jpg"
          alt="not_found"
        />
      </center>
    </>
  );
};

export default NotFound;
